<template>
  <div>
    <v-overlay :value="loading" :z-index="9999" opacity="0.9">
      <v-row class="fill-height" align="center" justify="center" style="flex-direction: column; text-align: center">
        <v-progress-circular indeterminate size="70" color="primary" class="mb-4" />
        <div class="text-h6 white--text">
          Anfrage wird bearbeitet! Upload erfolgt! Bitte warten...
        </div>
      </v-row>
    </v-overlay>
    <v-container>
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <v-btn
            :class="$vuetify.breakpoint.smAndDown ? '' : 'v-size--large'"
            :block="$vuetify.breakpoint.smAndDown"
            color="success"
            @click="openDialog({
              max_per_stream_is_enabled: 0,
              max_per_user_per_stream_is_enabled: 0,
              should_redemptions_skip_request_queue: 0,
              is_user_input_required: 0,
              is_enabled: 0,
              is_vip: 0,
            })"
          >Reward erstellen</v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            @click="toggleText"
            color="success"
            :block="$vuetify.breakpoint.smAndDown"
          >How To</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div class="channelPointsWrapper" :class="{ drawerOpen: !$store.state.navigation_drawer_mini, 'mobile-wrapper': $vuetify.breakpoint.smAndDown }">
      <v-row>
        <v-col v-for="item in sortedRewards" :key="item.id" cols="12" sm="6" md="4" lg="4">
          <v-card outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-h6 mb-4">{{ item.title }}</div>
                <v-list-item-title class="text-overline mb-2">{{ item.prompt }}</v-list-item-title>
                <v-list-item-subtitle>Reward Kosten: {{ item.cost }}</v-list-item-subtitle>
                <v-btn :color="item.is_bot_owner === 0 ? 'gray' : 'primary'" dark @click="openDialog(item)">
                  Belohnung bearbeiten
                </v-btn>
              </v-list-item-content>
              <v-list-item-avatar tile size="80" color="grey" v-if="item.img !== null && item.img !== ''">
                <img :src="getItemImage(item.img)" alt="Avatar">
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="showText" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showText = !showText">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>How To?</v-card-title>
        <v-card-text>
          <div>
            <p>
              Wie funktionieren Loyalty Rewards? <br><br>

              Es gibt grundsätzlich die Möglichkeiten eigne Loyalty Rewards zu erstellen.
              Damit können Sounds / Videos oder auch Bilder in der Stream via Rewards eingebunden werden.<br><br>

              Dafür muss der Streamer in sein OBS eine neue Browserquelle hinzufügen mit Breite 1920px und Höhe 1080px<br><br>

              Der Link lautet wie folgt:<font color="red"> {{baseUrl}}/alert/{{cmdlist_pubid}}</font><br><br>

              Sollte nun ein Reward eingelöst werden erscheint standardmäßig im Stream oben links ein Banner mit den
              Information wer hat den Reward eingelöst und welche.<br><br>
            </p>
          </div>
        </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-model="formValid">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error" @click="deleteReward" :hidden="selectedReward.id === undefined">
              Delete
            </v-btn>
            <v-btn color="success" @click="saveChanges">
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container class="pa-4">
          <v-subheader>Grundeinstellungen</v-subheader>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="selectedReward.title" label="Name des Rewards" outlined counter="45" maxLength="45"
                required :disabled="selectedReward.is_bot_owner === 0"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="selectedReward.cost" label="Kosten" outlined type="Number" :rules="rulesWith0" min="0" required
                :disabled="selectedReward.is_bot_owner === 0"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select v-model="selectedReward.lr_types" item-text="title" :items="lr_types" label="Reward für:"
                clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-file-input v-model="selectedReward.img" label="Bild auswählen" truncate-length="15"
                @change="onFileChange"></v-file-input>
              <v-btn
                v-if="selectedReward.img !== null && selectedReward.img !== '' && selectedReward.img !== undefined"
                color="red"
                @click="selectedReward.img = null"
              >Bild löschen</v-btn>
              <v-img :src="getItemImage(selectedReward.img)" max-width="100" max-height="100" class="mt-4"
                v-if="selectedReward.img !== null && selectedReward.img !== '' && selectedReward.img !== undefined"></v-img>
              <v-checkbox v-model="selectedReward.only_reward_img" :true-value="1" :false-value="0"
                label="Nur als Rewardbild verwenden!"
                v-if="selectedReward.img !== null && selectedReward.img !== '' && selectedReward.img !== undefined"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-file-input v-model="selectedReward.sound" label="Sound / Video auswählen" truncate-length="15"
                @change="onSoundChange"></v-file-input>
              <v-btn v-if="selectedReward.sound" color="red" @click="selectedReward.sound = null">Sound löschen</v-btn>
              <figure v-if="selectedReward.sound" class="mt-4">
                <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
                <audio controls :src="getItemImage(selectedReward.sound)" aria-hidden="true"></audio>
              </figure>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="selectedReward.prompt" label="Beschreibung" rows="1" auto-grow outlined counter="200"
                maxLength="200" :disabled="selectedReward.is_bot_owner === 0"></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" v-if="selectedReward.id">
              <v-switch v-model="selectedReward.is_paused" label="Belohnung in Pause versetzen" color="success"
                :true-value="1" :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.should_redemptions_skip_request_queue"
                label="Belohnungsanfrage überspringen" color="success" :true-value="1" :false-value="0" hide-details
                @change="saveSwitchState(selectedReward)" :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.is_user_input_required" label="Ist eine Usereingabe erforderlich?"
                color="success" :true-value="1" :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.is_enabled"
                label="Belohnung ist sichtbar in den Loyality Reward Übersicht" color="success" :true-value="1"
                :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.max_per_stream_is_enabled"
                label="Maximale Einlösungen pro Stream aktivieren" color="success" :true-value="1" :false-value="0"
                hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="selectedReward.max_per_stream" label="Maximale Einlösungen pro Stream" outlined
                :rules="selectedReward.max_per_stream_is_enabled === 1 ? rulesPositiveNumber : []" min="1"
                type="Number" :disabled="selectedReward.is_bot_owner === 0 ||
                  selectedReward.max_per_stream_is_enabled === 0"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.max_per_user_per_stream_is_enabled"
                label="Maximale Einlösungen pro Stream pro User aktivieren" color="success" :true-value="1"
                :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="selectedReward.max_per_user_per_stream"
                label="Maximale Einlösungen pro Stream pro User" outlined type="Number"
                :rules="selectedReward.max_per_user_per_stream_is_enabled === 1 ? rulesPositiveNumber : []" min="1"
                :disabled="selectedReward.is_bot_owner === 0 ||
                  selectedReward.max_per_user_per_stream_is_enabled === 0"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="selectedReward.chat_msg" label="Ausgabe bei Einlösung im Chat" color="success"
                :true-value="1" :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
                :disabled="selectedReward.is_bot_owner === 0"></v-switch>
            </v-col>
          </v-row>
        </v-container>
        <!-- <v-divider></v-divider>
        <h3 class="text-center">Discord Benachrichtigungseinstellungen!</h3>
        <v-list-item>
          <v-list-item-content>
            <v-switch v-model="selectedReward.dc_priv_msg" label="User benachrichtigen" color="success" :true-value="1"
              :false-value="0" hide-details @change="saveSwitchState(selectedReward)"
              :disabled="selectedReward.is_bot_owner === 0"></v-switch>
          </v-list-item-content>
          <v-list-item-content>
            <v-text-field v-model="selectedReward.dc_twitchname"
              label="Twitchuser der per Discord benachrichtigt werden soll" outlined :disabled="selectedReward.is_bot_owner === 0 ||
                selectedReward.dc_priv_msg === 0"></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-text-field v-model="selectedReward.dc_priv_msgcontent"
              label="Discordnachricht die der angegebene User erhalten soll." outlined :disabled="selectedReward.is_bot_owner === 0 ||
                selectedReward.dc_priv_msg === 0"></v-text-field>
          </v-list-item-content>
        </v-list-item> -->
        </v-form>
      </v-card>
      <v-snackbar
      v-model="ErrorFlag"
      timeout="3000"
      color="red"
    >
      Überprüfe die roten Felder!

      <template v-slot:actions>
        <v-btn
          color="pink"
          variant="text"
          @click="ErrorFlag = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    </v-dialog>

    <v-dialog v-model="showNotification" max-width="600" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showNotification = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Fehler!!!</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div class="text-h5 pa-12" style="color: red;">Leider kann diese Kanalpunktebelohnung
            nicht editiert werden! Der Grund dafür ist, dass diese
            Belohnung nicht vom Dashboard aus erstellt wurde!</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card>
        <v-card-title class="text-h5">Bist du dir sicher, dass diese
          Kanalpunktebelohnung gelöscht werden soll?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorReedemReward" timeout="5000" color="red">
      {{ dynamicErrorMsg }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="errorReedemReward = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      dialogDelete: false,
      showDialog: false,
      selectedIndex: 0,
      reward: [],
      errorReedemReward: false,
      dynamicErrorMsg: '',
      selectedReward: {
        id: '',
        title: '',
        prompt: '',
        is_bot_owner: '',
        cost: '',
        is_paused: '',
        should_redemptions_skip_request_queue: '',
        is_user_input_required: '',
        max_per_stream_is_enabled: '',
        max_per_stream: '',
        max_per_user_per_stream_is_enabled: '',
        max_per_user_per_stream: '',
        is_enabled: '',
        chat_msg: '',
        dc_priv_msg: '',
        dc_twitchname: '',
        dc_priv_msgcontent: '',
      },
      showNotification: false,
      loading: false,
      previousFile: null,
      fileChanged: false,
      fileWasCleared: false,
      fileInitiallySelected: false,
      previousSound: null,
      soundChanged: false,
      soundWasCleared: false,
      soundInitiallySelected: false,
      showText: false,
      baseUrl: '',
      cmdlist_pubid: '',
      lr_types: [
        {
          value: 1,
          title: 'Zum zusammen Zocken',
        },
        {
          value: 2,
          title: 'Eine weitere beliebige Warteschlange',
        },
        {
          value: 3,
          title: 'Spotify Songrequest',
        },
        // {
        //   value: 5,
        //   title: 'vipForTime',
        // },
        {
          value: 6,
          title: 'Zum Skippen des aktuellen Songs',
        },
      ],
      formValid: false, // zentraler Validierungsstatus
      rulesPositiveNumber: [
        (v) => !!v || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      rulesWith0: [
        (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
        (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
        (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
        (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
      ],
      ErrorFlag: false,
    };
  },
  mounted() {
    this.baseUrl = window.location.origin;
    BackendService.loadLoyaltiyRewards().then((data) => {
      this.reward = data.data;
      // console.log(this.reward);
    });
    BackendService.loadCMD_PubID({
      broadcasterid: this.$store.state.hostId,
    }).then((data) => {
      // console.log(data.data);const targetArray = data.data.find((item1) => item1.id === item.id);
      // console.log(targetArray);
      // console.log('Daten für OBS Token!');
      // console.log(data.data);
      this.cmdlist_pubid = data.data.cmdlist_pubid;
    });
  },
  computed: {
    sortedRewards() {
      const sortedArray = this.reward.slice();
      sortedArray.sort((a, b) => {
        if (a.cost !== b.cost) {
          return a.cost - b.cost;
        }
        return a.title.localeCompare(b.title);
      });

      return sortedArray;
    },
  },
  methods: {
    toggleText() {
      this.showText = !this.showText; // Text an/aus schalten
    },
    onFileChange(file) {
      // Fall: Datei gelöscht
      if (!file) {
        this.fileWasCleared = true;
        this.previousFile = null;
        // console.log('Datei wurde gelöscht');
        return;
      }

      this.fileWasCleared = false;

      // Fall: Erste Auswahl (keine Datei vorher)
      if (!this.fileInitiallySelected) {
        this.fileInitiallySelected = true;
        this.fileChanged = true;
        // console.log('Erste Datei ausgewählt');
      }

      // Fall: Neue Datei gewählt
      if (
        !this.previousFile
        || file.name !== this.previousFile.name
        || file.size !== this.previousFile.size
        || file.lastModified !== this.previousFile.lastModified
      ) {
        this.fileChanged = true;
        this.previousFile = file;
        // console.log('Neue Datei gewählt');
      } else {
        this.fileChanged = false;
      }
    },
    onSoundChange(sound) {
      // Fall: Datei gelöscht
      if (!sound) {
        this.soundWasCleared = true;
        this.previousSound = null;
        // console.log('Datei wurde gelöscht');
        return;
      }

      this.soundWasCleared = false;

      // Fall: Erste Auswahl (keine Datei vorher)
      if (!this.soundInitiallySelected) {
        this.soundInitiallySelected = true;
        this.soundChanged = true;
        // console.log('Erste Datei ausgewählt');
      }

      // Fall: Neue Datei gewählt
      if (
        !this.previousSound
        || sound.name !== this.previousSound.name
        || sound.size !== this.previousSound.size
        || sound.lastModified !== this.previousSound.lastModified
      ) {
        this.soundChanged = true;
        this.previousSound = sound;
        // console.log('Neue Datei gewählt');
      } else {
        this.soundChanged = false;
      }
    },
    getItemImage(path) {
      if (path === null || path === '') {
        return '';
      }
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL}img/${path}`;
    },
    openDialog(item) {
      if (item.is_bot_owner === 0) {
        this.showNotification = true;
        return;
      }

      this.selectedReward = { ...item };
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    saveChanges() {
      if (this.$refs.form.validate()) {
        if (this.selectedReward.id) {
          // Item bearbeiten
          // console.log(this.selectedReward);
          this.loading = true;
          // console.log('LOADING!!!');
          this.selectedReward.deleteCurrentImage = this.fileWasCleared;
          this.selectedReward.changeCurrentImage = this.fileChanged;
          this.selectedReward.deleteCurrentSound = this.soundWasCleared;
          this.selectedReward.changeCurrentSound = this.soundChanged;
          this.fileWasCleared = false;
          this.fileChanged = false;
          this.soundChanged = false;
          this.soundWasCleared = false;
          BackendService.updateLoyaltiyReward(this.selectedReward)
            .then((data) => {
              // Aktualisiere den Store mit der Mutationsmethode
              this.reward = data.data.rewards;
              this.showDialog = false;
            }).catch((error) => {
              // console.log(error.response.status);
              // console.log(error.response.data);
              if (error.response.status === 409 && error.response.data === 'user_not_connected_with_streamer_dc') {
                this.dynamicErrorMsg = 'Der angegebene User ist nicht mit dem Streamer DC verbunden!';
                this.errorReedemReward = true;
              } else if (error.response.status === 409 && error.response.data === 'streamer_not_connected_with_dc_bot') {
                this.dynamicErrorMsg = 'Streamer benutzt aktuell den DC-Bot nicht!';
                this.errorReedemReward = true;
              } else if (error.response.status === 409 && error.response.data === 'twitchuser_not_found') {
                this.dynamicErrorMsg = 'Der angegebene Twitchuser wurde nicht gefunden!';
                this.errorReedemReward = true;
              }
            }).finally(() => {
              this.loading = false;
            });
        } else {
          // Neues Item hinzufügen
          this.loading = true;
          this.fileWasCleared = false;
          this.fileChanged = false;
          this.soundChanged = false;
          this.soundWasCleared = false;
          BackendService.createLoyaltiyReward(this.selectedReward)
            .then((data) => {
              this.reward = data.data.rewards;
              this.showDialog = false;
            }).catch((error) => {
              // console.log(error.response.status);
              // console.log(error.response.data);
              if (error.response.status === 409 && error.response.data === 'user_not_connected_with_streamer_dc') {
                this.dynamicErrorMsg = 'Der angegebene User ist nicht mit dem Streamer DC verbunden!';
                this.errorReedemReward = true;
              } else if (error.response.status === 409 && error.response.data === 'streamer_not_connected_with_dc_bot') {
                this.dynamicErrorMsg = 'Streamer benutzt aktuell den DC-Bot nicht!';
                this.errorReedemReward = true;
              } else if (error.response.status === 409 && error.response.data === 'twitchuser_not_found') {
                this.dynamicErrorMsg = 'Der angegebene Twitchuser wurde nicht gefunden!';
                this.errorReedemReward = true;
              }
            }).finally(() => {
              this.loading = false;
            });
        }
      } else this.ErrorFlag = true;
    },
    saveSwitchState(item) {
      if (item.is_paused) {
        this.selectedReward.is_paused = 1;
      } else {
        this.selectedReward.is_paused = 0;
      }
      if (item.is_vip) {
        this.selectedReward.is_vip = 1;
      } else {
        this.selectedReward.is_vip = 0;
      }
      if (item.is_enabled) {
        this.selectedReward.is_enabled = 1;
      } else {
        this.selectedReward.is_enabled = 0;
      }
      if (item.is_user_input_required) {
        this.selectedReward.is_user_input_required = 1;
      } else {
        this.selectedReward.is_user_input_required = 0;
      }
      if (item.max_per_user_per_stream_is_enabled) {
        this.selectedReward.max_per_user_per_stream_is_enabled = 1;
      } else {
        this.selectedReward.max_per_user_per_stream_is_enabled = 0;
      }
      if (item.max_per_stream_is_enabled) {
        this.selectedReward.max_per_stream_is_enabled = 1;
      } else {
        this.selectedReward.max_per_stream_is_enabled = 0;
      }
      if (item.should_redemptions_skip_request_queue) {
        this.selectedReward.should_redemptions_skip_request_queue = 1;
      } else {
        this.selectedReward.should_redemptions_skip_request_queue = 0;
      }
      if (item.chat_msg) {
        this.selectedReward.chat_msg = 1;
      } else {
        this.selectedReward.chat_msg = 0;
      }
    },
    deleteReward() {
      // console.log(this.selectedReward.id);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      // console.log(this.selectedReward.id);
      // console.log('LÖSCHEN!!!');
      BackendService.deleteLoyaltiyReward(this.selectedReward).then((data) => {
        this.dialogDelete = false;
        this.showDialog = false;
        this.reward = data.data.rewards;
      });
    },
    closeDelete() {
      // console.log(this.selectedReward.id);
      // console.log('NICHT LÖSCHEN!!!');
      this.dialogDelete = false;
    },
  },
};
</script>
<style scoped>
html, body {
  margin: 0;
  padding: 0;
  background: transparent;
  overflow: auto; /* verhindert Scrollbars in OBS */
}

.channelPointsWrapper {
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
  background: transparent;
  margin: 0;

  /* Klicks standardmäßig durchlassen */
  pointer-events: none;
}

.channelPointsWrapper.mobile-wrapper {
  padding-left: 8px;
  padding-right: 8px;
}

.channelPointsWrapper * {
  /* Interaktive Elemente in den Channel Points wieder aktiv machen */
  pointer-events: auto;
}

</style>
